import {
  IService,
  IServiceData
} from './index'
import {
  ServiceTypePriceReverse,
  IServiceTypePriceReverse,
} from '../index'

export class Service implements IService {
  readonly id?: number
  readonly limit?: number
  service_type_priced: IServiceTypePriceReverse

  constructor(data: IServiceData) {
    this.id = data.id
    let limit = data.limit
    this.limit = this.validateLimit(limit) ? limit : undefined
    this.service_type_priced = new ServiceTypePriceReverse(data.service_type_priced)
  }

  validate(): boolean {
    return this.service_type_priced.validate() && this.validateLimit()
  }

  validateLimit(limit?: number): boolean {
    limit = (limit === undefined) ? this.limit : limit
    return (limit !== undefined) && limit >= 0
  }

  update(data?: IServiceData) {
    let type = data?.service_type_priced
    if (type) {
      this.service_type_priced.update(type)
    }
  }

  get total(): number {
    return this.service_type_priced.price * (this.limit || 0)
  }

}